import { stripLanguageCountry } from 'js/helpers/localization';
import { CURRENT_LANGUAGE_UPDATE } from '../reducers/nav/localization';
export function updateCurrentLanguage(unstrippedLanguage) {
  var language = stripLanguageCountry(unstrippedLanguage);
  return {
    type: CURRENT_LANGUAGE_UPDATE,
    language: language
  };
}